import icon from "images/icons/icon-delay.svg"

interface Props {
  title: string
}

export default function DelayIcon({ title }: Props) {
  return <span className="svg-icon" title={title} dangerouslySetInnerHTML={{ __html: icon }} />
}
